(function ($, w, d) {
    'use strict';

    $(d).ready(function () {
        let $mainMenu = $('#main_menu');

        if ($mainMenu.length) {
            let $menuToggler = $('.menu-toggler'), $menuClose = $('#main_menu .close');

            $menuToggler.on('click', function () {
                $mainMenu.addClass('active');
            });

            $menuClose.on('click', function () {
                $mainMenu.removeClass('active');
            });
        }

        let allPanels = $('.accorderon > ul > li > ul'), timer = false;

        $('.accorderon .link').click(function () {
            allPanels.slideUp();
            $(this).next().slideDown();

            return false;
        });

        $('[data-fancybox="feedback"]').fancybox({
            type: "ajax",
            opts: {
                ajax: {
                    settings: {
                        method: 'POST'
                    }
                },
            }
        });
    });
})(jQuery, window, document);